import React from 'react';
import { ContainerOuter, ResponseContainer, ResponseMessage } from '../Submitted/styles';

const PaymentCompleted = () => {
    return (
        <ContainerOuter>
            <ResponseContainer>
                <div className="d-flex flex-column align-items-center">
                    <img src='/Assets/tick.png' alt={'Payment Successful'} />
                    <ResponseMessage>Payment Successful !</ResponseMessage>
                    <ResponseMessage className="p-2">
                        We are delighted to inform you that we received your payments
                    </ResponseMessage>
                </div>
            </ResponseContainer>
        </ContainerOuter>
    );
};

export default PaymentCompleted;